// import './SelectStatus.css';

import { useEffect, useState } from 'react';

import { servGetAllStatusEmAberto } from '../../servicos/servicosEmRotasPrivadas/status';

// function SelectStatusSemLabel({ setStatus }) {
function SelectStatusControlled({ id, value, onChange }) {
    
    const [statusList, setStatusList] = useState([])

    useEffect(() => {
        getAllStatus()
    }, []);

    const getAllStatus = async () => {
        try {
            const statusDaApi = await servGetAllStatusEmAberto()
            setStatusList(statusDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    // const handleChange = (e) => {
    //     const value = e.target.value || null; // Se for "" transforma em null
    //     setStatus(value)
    // };

    return (
        <div>
            {statusList ? (
                <div className="d-flex flex-column flex-md-row gap-1 p-1 align-items-center">
                    <select
                        className="form-select form-select-sm w-100"
                        id="status"
                        defaultValue={value || ''}
                        onChange={(e) => onChange(e.target.value || null)}
                    >
                        <option value="">Selecione uma opção</option>
                        {statusList.map((status) => (
                            <option key={status.id} value={status.id}>
                                {status.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando informações dos status...</p>
            )}
        </div>
    )
}

export default SelectStatusControlled